module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/map-marker-alt.svg?c09db673b86c4d8f64f084b88d623642";